import { render, staticRenderFns } from "./unionpay-pop.vue?vue&type=template&id=047eb9b3&scoped=true&"
import script from "./unionpay-pop.vue?vue&type=script&lang=js&"
export * from "./unionpay-pop.vue?vue&type=script&lang=js&"
import style0 from "./unionpay-pop.vue?vue&type=style&index=0&id=047eb9b3&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047eb9b3",
  null
  
)

export default component.exports